module.exports = __webpack_public_path__ + "static/media/checkteamwindow.08c13cdf.png";